import { BlockProps, ImageCardProps } from "@/utils/types";
import { BlockWrapper } from "./BlockWrapper";
import { ImageCard } from "../modules/ImageCard";
import { sanitize } from "@/utils/sanitize";

interface MediaCardsProps extends BlockProps {
  items: ImageCardProps[];
}

export const MediaCards = ({
  backgroundColor = "bg-white",
  bottom,
  className,
  colorStarter,
  componentId,
  heading,
  items,
  primaryEnder,
}: MediaCardsProps) => {
  const lightModeTop =
    sanitize(backgroundColor) === "bg-white" ||
    sanitize(backgroundColor) === "pattern" ||
    sanitize(backgroundColor) === "bg-secondary" ||
    sanitize(backgroundColor) === "bg-tertiary";

  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    heading,
    lightMode: lightModeTop,
    primaryEnder,
  };
  const lightMode = backgroundColor
    ? sanitize(backgroundColor) === "bg-secondary"
    : false;
  return (
    <BlockWrapper
      {...blockProps}
      className={`mediaCards${className ? ` ${className}` : ""}`}
    >
      <div className="contained wide">
        <div className="flex flex-wrap items-center justify-center gap-8">
          {items?.map((item) => (
            <ImageCard {...item} key={item._key} lightMode={lightMode} />
          ))}
        </div>
      </div>
    </BlockWrapper>
  );
};
